import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { calcGST } from 'store/utility';
import { Modal, Form } from 'antd';
import QRForm from 'components/QRcode/Form/EditQRForm';
import styles from './EditModal.module.css';
import { connect } from 'react-redux';

class QREditModal extends Component {
  render = () => {
    const { onOk, onCancel, visible, form, data, isLoading, settings } = this.props;
    return (
      <Modal title="Edit QR code" visible={visible} onCancel={onCancel} onOk={onOk} confirmLoading={isLoading}>
        <div style={{ marginBottom: '10px' }}>
          <span>Original Price:</span>
        </div>
        <div className={styles.clearfix}>
          <div style={{ width: '40%', marginBottom: '5px' }}>
            <span style={{ float: 'left' }}>Price (w/o GST): </span>
            <span style={{ float: 'right' }}>
              {`$${(data.price_cents / 100).toFixed(2)}`} {data.price_unit}
            </span>
          </div>
          <br />
          <div style={{ width: '40%', marginBottom: '5px' }}>
            <span style={{ float: 'left' }}>Price (w GST): </span>
            <span style={{ float: 'right' }}>
              {calcGST(data.price_cents, data.gst ? data.gst : settings ? settings.gst : 0)} {data.price_unit}
            </span>
          </div>
          <br />
        </div>
        <hr />
        <QRForm form={form} data={data} />
      </Modal>
    );
  };
}

QREditModal.proptypes = {
  onOk: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    loggedInRole: state.auth.role,
    settings: state.setting.settings,
  };
};

const ModalForm = Form.create()(connect(mapStateToProps)(QREditModal));

export default ModalForm;



// WEBPACK FOOTER //
// ./src/components/QRcode/Modal/EditModal.js